import React from 'react';
import { Box, ContentContainer, Stack } from '@facet-wealth/design';
import PropTypes from 'prop-types';


const PageContentContainer = ({ children, maxWidth }) => {
  return (
    <Box margin={400}>
      <ContentContainer maxWidth={maxWidth}>
        <Stack direction={'column'} alignItems={'stretch'} spacing={2} justifyContent="flex-start">{children}</Stack>
      </ContentContainer>
    </Box>
  );
};

PageContentContainer.defaultProps = {
  maxWidth: 'sm',
};

PageContentContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'xl']),
};

export default PageContentContainer;
